import http from './http.config'

export const fetchAppointments = (params = {}) =>
  http.get('/appointments/list', { params }).then((res) => res.data)

export const fetchVendorAppointments = (params = {}) =>
  http.get('/vendors/appointments', { params }).then((res) => res.data)

export const fetchProviderAppointments = (params = {}) =>
  http.get('/providers/appointments', { params }).then((res) => res.data)

export const fetchCustomerAppointments = (params = {}) =>
  http.get('/customers/appointments', { params }).then((res) => res.data)

export const fetchVendorAppointmentDetails = (id, params = {}) =>
  http.get(`/vendors/appointments/${id}/details`, { params }).then((res) => res.data)

export const fetchCustomerAppointmentDetail = (id, params = {}) =>
  http.get(`/customers/appointments/${id}/details`, { params }).then((res) => res.data)

export const rescheduleAppointment = (
  id: string | number,
  payload: {
    preferred_date: string;
    preferred_time: string;
    note?: string | null;
  },
) => http.post(`/customers/appointments/${id}/reschedule-request`, payload).then((res) => res.data)

export const cancelAppointment = (
  id: string | number,
  payload: {
    reason: string;
  },
) => http.post(`/customers/appointments/${id}/cancellation-request`, payload).then((res) => res.data)

export const cancelVendorAppointment = (
  id: string | number,
  payload: {
    refund_type: "full" | "partial" | "none" | "reject";
    refund_amount?: number;
    reason?: string;
  },
) => http.post(`/vendors/appointments/${id}/cancel`, payload).then((res) => res.data)


export const fetchAppointmentById = (id, params = {}) =>
  http.get(`/appointments/${id}`, { params }).then((res) => res.data)

export const fetchTodaysAppointments = (params = {}) =>
  http.get('/appointments/today', { params }).then((res) => res.data)

export const assignAppointmentServiceProvider = (
  id: string | number,
  payload: { provider_id: string | number }
) => http.post(`/vendors/appointments/${id}/assign-provider`, payload).then((res) => res.data)

export const approveAppointmentReschedule = (
  id: string | number,
  payload: {
    preferred_date: string;
    preferred_time: string;
  },
) => http.post(`/vendors/appointments/${id}/reschedule`, payload).then((res) => res.data)



// providers
export const fetchProviderAppointmentDetails = (id, params = {}) =>
  http.get(`/providers/appointments/${id}/details`, { params }).then((res) => res.data)

export const updateAppointmentStatus = (
  id: string | number,
  payload: {
    code: string;
    action: string;
    description?: string;
    preferred_date?: string;
    preferred_time?: string;
  }
) => http.post(`/providers/appointments/${id}/update-action`, payload).then((res) => res.data)

export const submitAppointmentSurvey = (
  id: string | number,
  payload: Record<string, unknown>
) => http.post(`/providers/appointments/${id}/survey-save`, payload).then((res) => res.data)
